import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "date-color" }
const _hoisted_2 = { class: "pa-2" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = { style: {"position":"sticky","bottom":"0","background-color":"white","padding":"20px","box-shadow":"0px 4px 10px 0px #0000000D"} }

import {computed, onMounted, reactive, ref} from "vue";
import {surveysService} from "@/api/services/surveys";
import {useSettingsStore} from "@/api/store/settings";
import {useRouter} from "vue-router";
import moment from "moment";
import RatingSlider from "@/components/custom/RatingSlider.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'DocumentSurveyForm',
  setup(__props) {

const settingsStore = useSettingsStore();
const router = useRouter();

const state = reactive({
  survey: {},
});

const disableSubmission = ref(false);

const getSurveysQuestions = () => {
  

  surveysService.show(router.currentRoute.value.params.surveyId as number).then((response) => {

    if(response.questions !== undefined) {
      state.survey = {
        ...response,
        questions: response.questions.map((question: any) => {
          return {
            ...question,
            answer: 0,
            comment: ""
          }
        })
      };
    }

    router.currentRoute.value.meta.showTitleBar = true;
    router.currentRoute.value.meta.title = state.survey.name;

    
  });
}

const isSubmissionAllowed = computed(() => {
  if (!state.survey.questions || state.survey.questions.length === 0) {
    return false;
  }
  return state.survey.questions.every(question => question.answer >= 1);
});

const submitAnswers = () => {
  if (!isSubmissionAllowed.value) return;

  disableSubmission.value = true;

  surveysService.store(state.survey, router.currentRoute.value.params.clientSurveyId).then(() => {
    disableSubmission.value = false;
    router.push({name: 'document-surveys'});
  });
}

onMounted(() => {
  getSurveysQuestions()
});

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_component_v_container, {
    class: "px-0 pb-0 surveys",
    style: {"background-color":"#F0F0F0","position":"relative"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "date-label mx-3" }, {
        default: _withCtx(() => [
          _cache[0] || (_cache[0] = _createTextVNode(" Entry: ", -1)),
          _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(moment)().format('DD MMM YYYY')), 1)
        ]),
        _: 1
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.survey.questions, (question, index) => {
        return (_openBlock(), _createBlock(_component_v_container, {
          key: `survey-${index}`,
          class: "px-6 py-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_sheet, { class: "border-rounded pa-3 mb-3" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("p", _hoisted_3, _toDisplayString(question.title), 1),
                  _createVNode(RatingSlider, {
                    modelValue: question.answer,
                    "onUpdate:modelValue": ($event: any) => ((question.answer) = $event),
                    color: _unref(settingsStore).settings.primaryColor,
                    question: question
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "color", "question"])
                ])
              ]),
              _: 2
            }, 1024),
            (question.enable_comments == 1)
              ? (_openBlock(), _createBlock(_component_v_textarea, {
                  key: 0,
                  modelValue: question.comment,
                  "onUpdate:modelValue": ($event: any) => ((question.comment) = $event),
                  density: "compact",
                  "no-resize": "",
                  placeholder: "Add a Comment...",
                  rows: "1",
                  variant: "solo"
                }, null, 8, ["modelValue", "onUpdate:modelValue"]))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1024))
      }), 128)),
      _createElementVNode("section", _hoisted_4, [
        _createVNode(_component_v_btn, {
          color: !isSubmissionAllowed.value || disableSubmission.value ? '#ABAAAA' : _unref(settingsStore).settings.buttonColor2,
          disabled: !isSubmissionAllowed.value || disableSubmission.value,
          class: "b-round-20 primary-button",
          onClick: submitAnswers
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode(" Submit ", -1)
          ]))]),
          _: 1
        }, 8, ["color", "disabled"])
      ])
    ]),
    _: 1
  }))
}
}

})